module.exports = __webpack_public_path__ + "bb5c55b8a6daf8094239137b97125aee.svg";